import CtaButton from './cta-button-view';

export default CtaButton;